import { j as T } from "./jsx-runtime-Bdg6XQ1m.js";
import * as R from "@radix-ui/react-dialog";
import { X as Le } from "lucide-react";
import * as a from "react";
import xe from "react";
import { c as Q } from "./cn-qaFjX9_3.js";
import { Primitive as N } from "@radix-ui/react-primitive";
import { useId as P } from "@radix-ui/react-id";
const ht = R.Root, St = R.Trigger, Te = R.Portal, _e = a.forwardRef(({ className: e, ...n }, t) => /* @__PURE__ */ T.jsx(
  R.Overlay,
  {
    ref: t,
    className: Q(
      "fixed inset-0 z-50 bg-black/80  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...n
  }
));
_e.displayName = R.Overlay.displayName;
const Ne = a.forwardRef(({ className: e, children: n, ...t }, f) => /* @__PURE__ */ T.jsxs(Te, { children: [
  /* @__PURE__ */ T.jsx(_e, {}),
  /* @__PURE__ */ T.jsxs(
    R.Content,
    {
      ref: f,
      className: Q(
        "fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg",
        e
      ),
      ...t,
      children: [
        n,
        /* @__PURE__ */ T.jsxs(R.Close, { className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground", children: [
          /* @__PURE__ */ T.jsx(Le, { className: "h-4 w-4" }),
          /* @__PURE__ */ T.jsx("span", { className: "sr-only", children: "Close" })
        ] })
      ]
    }
  )
] }));
Ne.displayName = R.Content.displayName;
const Me = a.forwardRef(({ className: e, ...n }, t) => /* @__PURE__ */ T.jsx(
  R.Title,
  {
    ref: t,
    className: Q(
      "text-lg font-semibold leading-none tracking-tight",
      e
    ),
    ...n
  }
));
Me.displayName = R.Title.displayName;
const Ve = a.forwardRef(({ className: e, ...n }, t) => /* @__PURE__ */ T.jsx(
  R.Description,
  {
    ref: t,
    className: Q("text-sm text-muted-foreground", e),
    ...n
  }
));
Ve.displayName = R.Description.displayName;
var he = 1, $e = 0.9, je = 0.8, Ke = 0.17, ne = 0.1, ae = 0.999, qe = 0.9999, Ue = 0.99, Pe = /[\\\/_+.#"@\[\(\{&]/, Fe = /[\\\/_+.#"@\[\(\{&]/g, Be = /[\s-]/, Oe = /[\s-]/g;
function oe(e, n, t, f, l, o, d) {
  if (o === n.length) return l === e.length ? he : Ue;
  var v = `${l},${o}`;
  if (d[v] !== void 0) return d[v];
  for (var h = f.charAt(o), p = t.indexOf(h, l), s = 0, i, S, E, k; p >= 0; ) i = oe(e, n, t, f, p + 1, o + 1, d), i > s && (p === l ? i *= he : Pe.test(e.charAt(p - 1)) ? (i *= je, E = e.slice(l, p - 1).match(Fe), E && l > 0 && (i *= Math.pow(ae, E.length))) : Be.test(e.charAt(p - 1)) ? (i *= $e, k = e.slice(l, p - 1).match(Oe), k && l > 0 && (i *= Math.pow(ae, k.length))) : (i *= Ke, l > 0 && (i *= Math.pow(ae, p - l))), e.charAt(p) !== n.charAt(o) && (i *= qe)), (i < ne && t.charAt(p - 1) === f.charAt(o + 1) || f.charAt(o + 1) === f.charAt(o) && t.charAt(p - 1) !== f.charAt(o)) && (S = oe(e, n, t, f, p + 1, o + 2, d), S * ne > i && (i = S * ne)), i > s && (s = i), p = t.indexOf(h, p + 1);
  return d[v] = s, s;
}
function Se(e) {
  return e.toLowerCase().replace(Oe, " ");
}
function Ge(e, n, t) {
  return e = t && t.length > 0 ? `${e + " " + t.join(" ")}` : e, oe(e, n, Se(e), Se(n), 0, 0, {});
}
var J = { exports: {} }, le = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ye;
function He() {
  if (ye) return le;
  ye = 1;
  var e = xe;
  function n(i, S) {
    return i === S && (i !== 0 || 1 / i === 1 / S) || i !== i && S !== S;
  }
  var t = typeof Object.is == "function" ? Object.is : n, f = e.useState, l = e.useEffect, o = e.useLayoutEffect, d = e.useDebugValue;
  function v(i, S) {
    var E = S(), k = f({ inst: { value: E, getSnapshot: S } }), C = k[0].inst, D = k[1];
    return o(function() {
      C.value = E, C.getSnapshot = S, h(C) && D({ inst: C });
    }, [i, E, S]), l(function() {
      return h(C) && D({ inst: C }), i(function() {
        h(C) && D({ inst: C });
      });
    }, [i]), d(E), E;
  }
  function h(i) {
    var S = i.getSnapshot;
    i = i.value;
    try {
      var E = S();
      return !t(i, E);
    } catch {
      return !0;
    }
  }
  function p(i, S) {
    return S();
  }
  var s = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? p : v;
  return le.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : s, le;
}
var ue = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ee;
function ze() {
  return Ee || (Ee = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = xe, n = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function t(x) {
      {
        for (var b = arguments.length, O = new Array(b > 1 ? b - 1 : 0), m = 1; m < b; m++)
          O[m - 1] = arguments[m];
        f("error", x, O);
      }
    }
    function f(x, b, O) {
      {
        var m = n.ReactDebugCurrentFrame, _ = m.getStackAddendum();
        _ !== "" && (b += "%s", O = O.concat([_]));
        var L = O.map(function(A) {
          return String(A);
        });
        L.unshift("Warning: " + b), Function.prototype.apply.call(console[x], console, L);
      }
    }
    function l(x, b) {
      return x === b && (x !== 0 || 1 / x === 1 / b) || x !== x && b !== b;
    }
    var o = typeof Object.is == "function" ? Object.is : l, d = e.useState, v = e.useEffect, h = e.useLayoutEffect, p = e.useDebugValue, s = !1, i = !1;
    function S(x, b, O) {
      s || e.startTransition !== void 0 && (s = !0, t("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var m = b();
      if (!i) {
        var _ = b();
        o(m, _) || (t("The result of getSnapshot should be cached to avoid an infinite loop"), i = !0);
      }
      var L = d({
        inst: {
          value: m,
          getSnapshot: b
        }
      }), A = L[0].inst, M = L[1];
      return h(function() {
        A.value = m, A.getSnapshot = b, E(A) && M({
          inst: A
        });
      }, [x, m, b]), v(function() {
        E(A) && M({
          inst: A
        });
        var F = function() {
          E(A) && M({
            inst: A
          });
        };
        return x(F);
      }, [x]), p(m), m;
    }
    function E(x) {
      var b = x.getSnapshot, O = x.value;
      try {
        var m = b();
        return !o(O, m);
      } catch {
        return !0;
      }
    }
    function k(x, b, O) {
      return b();
    }
    var C = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", D = !C, q = D ? k : S, X = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : q;
    ue.useSyncExternalStore = X, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), ue;
}
var be;
function We() {
  return be || (be = 1, process.env.NODE_ENV === "production" ? J.exports = He() : J.exports = ze()), J.exports;
}
var Xe = We(), H = '[cmdk-group=""]', ie = '[cmdk-group-items=""]', Ye = '[cmdk-group-heading=""]', ce = '[cmdk-item=""]', we = `${ce}:not([aria-disabled="true"])`, se = "cmdk-item-select", $ = "data-value", Je = (e, n, t) => Ge(e, n, t), Re = a.createContext(void 0), W = () => a.useContext(Re), ke = a.createContext(void 0), de = () => a.useContext(ke), Ce = a.createContext(void 0), De = a.forwardRef((e, n) => {
  let t = U(() => {
    var r, c;
    return { search: "", value: (c = (r = e.value) != null ? r : e.defaultValue) != null ? c : "", filtered: { count: 0, items: /* @__PURE__ */ new Map(), groups: /* @__PURE__ */ new Set() } };
  }), f = U(() => /* @__PURE__ */ new Set()), l = U(() => /* @__PURE__ */ new Map()), o = U(() => /* @__PURE__ */ new Map()), d = U(() => /* @__PURE__ */ new Set()), v = Ae(e), { label: h, children: p, value: s, onValueChange: i, filter: S, shouldFilter: E, loop: k, disablePointerSelection: C = !1, vimBindings: D = !0, ...q } = e, X = P(), x = P(), b = P(), O = a.useRef(null), m = ot();
  j(() => {
    if (s !== void 0) {
      let r = s.trim();
      t.current.value = r, _.emit();
    }
  }, [s]), j(() => {
    m(6, fe);
  }, []);
  let _ = a.useMemo(() => ({ subscribe: (r) => (d.current.add(r), () => d.current.delete(r)), snapshot: () => t.current, setState: (r, c, g) => {
    var u, y, w;
    if (!Object.is(t.current[r], c)) {
      if (t.current[r] = c, r === "search") ee(), M(), m(1, F);
      else if (r === "value" && (g || m(5, fe), ((u = v.current) == null ? void 0 : u.value) !== void 0)) {
        let I = c ?? "";
        (w = (y = v.current).onValueChange) == null || w.call(y, I);
        return;
      }
      _.emit();
    }
  }, emit: () => {
    d.current.forEach((r) => r());
  } }), []), L = a.useMemo(() => ({ value: (r, c, g) => {
    var u;
    c !== ((u = o.current.get(r)) == null ? void 0 : u.value) && (o.current.set(r, { value: c, keywords: g }), t.current.filtered.items.set(r, A(c, g)), m(2, () => {
      M(), _.emit();
    }));
  }, item: (r, c) => (f.current.add(r), c && (l.current.has(c) ? l.current.get(c).add(r) : l.current.set(c, /* @__PURE__ */ new Set([r]))), m(3, () => {
    ee(), M(), t.current.value || F(), _.emit();
  }), () => {
    o.current.delete(r), f.current.delete(r), t.current.filtered.items.delete(r);
    let g = B();
    m(4, () => {
      ee(), (g == null ? void 0 : g.getAttribute("id")) === r && F(), _.emit();
    });
  }), group: (r) => (l.current.has(r) || l.current.set(r, /* @__PURE__ */ new Set()), () => {
    o.current.delete(r), l.current.delete(r);
  }), filter: () => v.current.shouldFilter, label: h || e["aria-label"], getDisablePointerSelection: () => v.current.disablePointerSelection, listId: X, inputId: b, labelId: x, listInnerRef: O }), []);
  function A(r, c) {
    var g, u;
    let y = (u = (g = v.current) == null ? void 0 : g.filter) != null ? u : Je;
    return r ? y(r, t.current.search, c) : 0;
  }
  function M() {
    if (!t.current.search || v.current.shouldFilter === !1) return;
    let r = t.current.filtered.items, c = [];
    t.current.filtered.groups.forEach((u) => {
      let y = l.current.get(u), w = 0;
      y.forEach((I) => {
        let V = r.get(I);
        w = Math.max(V, w);
      }), c.push([u, w]);
    });
    let g = O.current;
    G().sort((u, y) => {
      var w, I;
      let V = u.getAttribute("id"), Y = y.getAttribute("id");
      return ((w = r.get(Y)) != null ? w : 0) - ((I = r.get(V)) != null ? I : 0);
    }).forEach((u) => {
      let y = u.closest(ie);
      y ? y.appendChild(u.parentElement === y ? u : u.closest(`${ie} > *`)) : g.appendChild(u.parentElement === g ? u : u.closest(`${ie} > *`));
    }), c.sort((u, y) => y[1] - u[1]).forEach((u) => {
      var y;
      let w = (y = O.current) == null ? void 0 : y.querySelector(`${H}[${$}="${encodeURIComponent(u[0])}"]`);
      w == null || w.parentElement.appendChild(w);
    });
  }
  function F() {
    let r = G().find((g) => g.getAttribute("aria-disabled") !== "true"), c = r == null ? void 0 : r.getAttribute($);
    _.setState("value", c || void 0);
  }
  function ee() {
    var r, c, g, u;
    if (!t.current.search || v.current.shouldFilter === !1) {
      t.current.filtered.count = f.current.size;
      return;
    }
    t.current.filtered.groups = /* @__PURE__ */ new Set();
    let y = 0;
    for (let w of f.current) {
      let I = (c = (r = o.current.get(w)) == null ? void 0 : r.value) != null ? c : "", V = (u = (g = o.current.get(w)) == null ? void 0 : g.keywords) != null ? u : [], Y = A(I, V);
      t.current.filtered.items.set(w, Y), Y > 0 && y++;
    }
    for (let [w, I] of l.current) for (let V of I) if (t.current.filtered.items.get(V) > 0) {
      t.current.filtered.groups.add(w);
      break;
    }
    t.current.filtered.count = y;
  }
  function fe() {
    var r, c, g;
    let u = B();
    u && (((r = u.parentElement) == null ? void 0 : r.firstChild) === u && ((g = (c = u.closest(H)) == null ? void 0 : c.querySelector(Ye)) == null || g.scrollIntoView({ block: "nearest" })), u.scrollIntoView({ block: "nearest" }));
  }
  function B() {
    var r;
    return (r = O.current) == null ? void 0 : r.querySelector(`${ce}[aria-selected="true"]`);
  }
  function G() {
    var r;
    return Array.from(((r = O.current) == null ? void 0 : r.querySelectorAll(we)) || []);
  }
  function te(r) {
    let c = G()[r];
    c && _.setState("value", c.getAttribute($));
  }
  function re(r) {
    var c;
    let g = B(), u = G(), y = u.findIndex((I) => I === g), w = u[y + r];
    (c = v.current) != null && c.loop && (w = y + r < 0 ? u[u.length - 1] : y + r === u.length ? u[0] : u[y + r]), w && _.setState("value", w.getAttribute($));
  }
  function pe(r) {
    let c = B(), g = c == null ? void 0 : c.closest(H), u;
    for (; g && !u; ) g = r > 0 ? ut(g, H) : it(g, H), u = g == null ? void 0 : g.querySelector(we);
    u ? _.setState("value", u.getAttribute($)) : re(r);
  }
  let me = () => te(G().length - 1), ve = (r) => {
    r.preventDefault(), r.metaKey ? me() : r.altKey ? pe(1) : re(1);
  }, ge = (r) => {
    r.preventDefault(), r.metaKey ? te(0) : r.altKey ? pe(-1) : re(-1);
  };
  return a.createElement(N.div, { ref: n, tabIndex: -1, ...q, "cmdk-root": "", onKeyDown: (r) => {
    var c;
    if ((c = q.onKeyDown) == null || c.call(q, r), !r.defaultPrevented) switch (r.key) {
      case "n":
      case "j": {
        D && r.ctrlKey && ve(r);
        break;
      }
      case "ArrowDown": {
        ve(r);
        break;
      }
      case "p":
      case "k": {
        D && r.ctrlKey && ge(r);
        break;
      }
      case "ArrowUp": {
        ge(r);
        break;
      }
      case "Home": {
        r.preventDefault(), te(0);
        break;
      }
      case "End": {
        r.preventDefault(), me();
        break;
      }
      case "Enter":
        if (!r.nativeEvent.isComposing && r.keyCode !== 229) {
          r.preventDefault();
          let g = B();
          if (g) {
            let u = new Event(se);
            g.dispatchEvent(u);
          }
        }
    }
  } }, a.createElement("label", { "cmdk-label": "", htmlFor: L.inputId, id: L.labelId, style: ct }, h), Z(e, (r) => a.createElement(ke.Provider, { value: _ }, a.createElement(Re.Provider, { value: L }, r))));
}), Qe = a.forwardRef((e, n) => {
  var t, f;
  let l = P(), o = a.useRef(null), d = a.useContext(Ce), v = W(), h = Ae(e), p = (f = (t = h.current) == null ? void 0 : t.forceMount) != null ? f : d == null ? void 0 : d.forceMount;
  j(() => {
    if (!p) return v.item(l, d == null ? void 0 : d.id);
  }, [p]);
  let s = Ie(l, o, [e.value, e.children, o], e.keywords), i = de(), S = K((m) => m.value && m.value === s.current), E = K((m) => p || v.filter() === !1 ? !0 : m.search ? m.filtered.items.get(l) > 0 : !0);
  a.useEffect(() => {
    let m = o.current;
    if (!(!m || e.disabled)) return m.addEventListener(se, k), () => m.removeEventListener(se, k);
  }, [E, e.onSelect, e.disabled]);
  function k() {
    var m, _;
    C(), (_ = (m = h.current).onSelect) == null || _.call(m, s.current);
  }
  function C() {
    i.setState("value", s.current, !0);
  }
  if (!E) return null;
  let { disabled: D, value: q, onSelect: X, forceMount: x, keywords: b, ...O } = e;
  return a.createElement(N.div, { ref: z([o, n]), ...O, id: l, "cmdk-item": "", role: "option", "aria-disabled": !!D, "aria-selected": !!S, "data-disabled": !!D, "data-selected": !!S, onPointerMove: D || v.getDisablePointerSelection() ? void 0 : C, onClick: D ? void 0 : k }, e.children);
}), Ze = a.forwardRef((e, n) => {
  let { heading: t, children: f, forceMount: l, ...o } = e, d = P(), v = a.useRef(null), h = a.useRef(null), p = P(), s = W(), i = K((E) => l || s.filter() === !1 ? !0 : E.search ? E.filtered.groups.has(d) : !0);
  j(() => s.group(d), []), Ie(d, v, [e.value, e.heading, h]);
  let S = a.useMemo(() => ({ id: d, forceMount: l }), [l]);
  return a.createElement(N.div, { ref: z([v, n]), ...o, "cmdk-group": "", role: "presentation", hidden: i ? void 0 : !0 }, t && a.createElement("div", { ref: h, "cmdk-group-heading": "", "aria-hidden": !0, id: p }, t), Z(e, (E) => a.createElement("div", { "cmdk-group-items": "", role: "group", "aria-labelledby": t ? p : void 0 }, a.createElement(Ce.Provider, { value: S }, E))));
}), et = a.forwardRef((e, n) => {
  let { alwaysRender: t, ...f } = e, l = a.useRef(null), o = K((d) => !d.search);
  return !t && !o ? null : a.createElement(N.div, { ref: z([l, n]), ...f, "cmdk-separator": "", role: "separator" });
}), tt = a.forwardRef((e, n) => {
  let { onValueChange: t, ...f } = e, l = e.value != null, o = de(), d = K((s) => s.search), v = K((s) => s.value), h = W(), p = a.useMemo(() => {
    var s;
    let i = (s = h.listInnerRef.current) == null ? void 0 : s.querySelector(`${ce}[${$}="${encodeURIComponent(v)}"]`);
    return i == null ? void 0 : i.getAttribute("id");
  }, []);
  return a.useEffect(() => {
    e.value != null && o.setState("search", e.value);
  }, [e.value]), a.createElement(N.input, { ref: n, ...f, "cmdk-input": "", autoComplete: "off", autoCorrect: "off", spellCheck: !1, "aria-autocomplete": "list", role: "combobox", "aria-expanded": !0, "aria-controls": h.listId, "aria-labelledby": h.labelId, "aria-activedescendant": p, id: h.inputId, type: "text", value: l ? e.value : d, onChange: (s) => {
    l || o.setState("search", s.target.value), t == null || t(s.target.value);
  } });
}), rt = a.forwardRef((e, n) => {
  let { children: t, label: f = "Suggestions", ...l } = e, o = a.useRef(null), d = a.useRef(null), v = W();
  return a.useEffect(() => {
    if (d.current && o.current) {
      let h = d.current, p = o.current, s, i = new ResizeObserver(() => {
        s = requestAnimationFrame(() => {
          let S = h.offsetHeight;
          p.style.setProperty("--cmdk-list-height", S.toFixed(1) + "px");
        });
      });
      return i.observe(h), () => {
        cancelAnimationFrame(s), i.unobserve(h);
      };
    }
  }, []), a.createElement(N.div, { ref: z([o, n]), ...l, "cmdk-list": "", role: "listbox", "aria-label": f, id: v.listId }, Z(e, (h) => a.createElement("div", { ref: z([d, v.listInnerRef]), "cmdk-list-sizer": "" }, h)));
}), nt = a.forwardRef((e, n) => {
  let { open: t, onOpenChange: f, overlayClassName: l, contentClassName: o, container: d, ...v } = e;
  return a.createElement(R.Root, { open: t, onOpenChange: f }, a.createElement(R.Portal, { container: d }, a.createElement(R.Overlay, { "cmdk-overlay": "", className: l }), a.createElement(R.Content, { "aria-label": e.label, "cmdk-dialog": "", className: o }, a.createElement(De, { ref: n, ...v }))));
}), at = a.forwardRef((e, n) => K((t) => t.filtered.count === 0) ? a.createElement(N.div, { ref: n, ...e, "cmdk-empty": "", role: "presentation" }) : null), lt = a.forwardRef((e, n) => {
  let { progress: t, children: f, label: l = "Loading...", ...o } = e;
  return a.createElement(N.div, { ref: n, ...o, "cmdk-loading": "", role: "progressbar", "aria-valuenow": t, "aria-valuemin": 0, "aria-valuemax": 100, "aria-label": l }, Z(e, (d) => a.createElement("div", { "aria-hidden": !0 }, d)));
}), yt = Object.assign(De, { List: rt, Item: Qe, Input: tt, Group: Ze, Separator: et, Dialog: nt, Empty: at, Loading: lt });
function ut(e, n) {
  let t = e.nextElementSibling;
  for (; t; ) {
    if (t.matches(n)) return t;
    t = t.nextElementSibling;
  }
}
function it(e, n) {
  let t = e.previousElementSibling;
  for (; t; ) {
    if (t.matches(n)) return t;
    t = t.previousElementSibling;
  }
}
function Ae(e) {
  let n = a.useRef(e);
  return j(() => {
    n.current = e;
  }), n;
}
var j = typeof window > "u" ? a.useEffect : a.useLayoutEffect;
function U(e) {
  let n = a.useRef();
  return n.current === void 0 && (n.current = e()), n;
}
function z(e) {
  return (n) => {
    e.forEach((t) => {
      typeof t == "function" ? t(n) : t != null && (t.current = n);
    });
  };
}
function K(e) {
  let n = de(), t = () => e(n.snapshot());
  return Xe.useSyncExternalStore(n.subscribe, t, t);
}
function Ie(e, n, t, f = []) {
  let l = a.useRef(), o = W();
  return j(() => {
    var d;
    let v = (() => {
      var p;
      for (let s of t) {
        if (typeof s == "string") return s.trim();
        if (typeof s == "object" && "current" in s) return s.current ? (p = s.current.textContent) == null ? void 0 : p.trim() : l.current;
      }
    })(), h = f.map((p) => p.trim());
    o.value(e, v, h), (d = n.current) == null || d.setAttribute($, v), l.current = v;
  }), l;
}
var ot = () => {
  let [e, n] = a.useState(), t = U(() => /* @__PURE__ */ new Map());
  return j(() => {
    t.current.forEach((f) => f()), t.current = /* @__PURE__ */ new Map();
  }, [e]), (f, l) => {
    t.current.set(f, l), n({});
  };
};
function st(e) {
  let n = e.type;
  return typeof n == "function" ? n(e.props) : "render" in n ? n.render(e.props) : e;
}
function Z({ asChild: e, children: n }, t) {
  return e && a.isValidElement(n) ? a.cloneElement(st(n), { ref: n.ref }, t(n.props.children)) : t(n);
}
var ct = { position: "absolute", width: "1px", height: "1px", padding: "0", margin: "-1px", overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0" };
export {
  ht as D,
  K as T,
  yt as V,
  Ne as a,
  St as b,
  Me as c
};
//# sourceMappingURL=index-B7mqiOei.js.map
